// Mirroring this type from card-associated-objects-lib so we don't end up with a circular dependency

export function isDeal(data) {
  return (data === null || data === void 0 ? void 0 : data.__typename) === 'Deal';
}
export function isQuote(data) {
  return (data === null || data === void 0 ? void 0 : data.__typename) === 'Quote';
}
export const ObjectConversionError = Object.freeze({
  STILL_LOADING: 'STILL_LOADING',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
  UNSUPPORTED_OBJECT_TYPE: 'UNSUPPORTED_OBJECT_TYPE',
  NO_OBJECT_TYPE: 'NO_OBJECT_TYPE',
  NO_OBJECT_ID: 'NO_OBJECT_ID',
  OBJECT_NOT_FOUND: 'OBJECT_NOT_FOUND',
  NO_CREATE_ACCESS: 'NO_CREATE_ACCESS'
});